import { Box, Button } from "@mui/material";
import * as React from "react";
import { useSelector } from "react-redux";
import {
  DealerLocation,
  LocationPart,
  LocationWholegood,
  MatchedProduct,
} from "../../../models/features/Integration/DmsSetup";
import { AppState } from "../../../redux/reducer/rootReducer";
import AppConfirmDialog from "../../app/AppConfirmDialog";
import { useDispatch } from "react-redux";
import {
  addMatchedProducts,
  addMissMatchedParts,
  addMissMatchedProducts,
  removeMatchProduct,
  useGetMatchingProductsV2Mutation,
} from "../../../redux/reducer/features/Integration/DmsSetupSlice";
import { useGetProductByIdMutation } from "../../../redux/reducer/features/Product/productSlice";
import { Product } from "../../../models/features/Product/Product";
import ProductDetail from "./Popup/ProductDetail";
import MatchingWholegoodsGrid from "./Grids/MatchingWholegoodsGrid";

interface MatchingProductsProps {
  handleNext: any;
  handleBack: any;
  locations: DealerLocation[];
  productTypesToProcess?: string[];
}

const MatchingProducts: React.FunctionComponent<MatchingProductsProps> = ({
  handleBack,
  handleNext,
  locations,
}) => {
  const { dmsSetup } = useSelector((state: AppState) => state.authReducer);
  const dispatch = useDispatch();
  const [confirmDialog, setConfirmDialog] = React.useState(false);
  const [selectedProduct, setSelectedProduct] = React.useState<Product>();
  const [selectedItem, setSelectedItem] = React.useState<MatchedProduct>();
  const [stock, setstock] = React.useState<any>([]);
  const [navigateOpen, setNavigateOpen] = React.useState(false);
  const [Formopen, setFormOpen] = React.useState(false);
  const [productByIdMutation, productByIdMutationResult] =
    useGetProductByIdMutation();
  const [getMatchingWhoolegoods, matchingWhoolegoodsMutationResult] =
    useGetMatchingProductsV2Mutation();

  const { matchedProducts, dmsWholeGoods, dmsParts, dmsManufacturers } =
    useSelector((state: AppState) => state.dmsReducer);

  React.useEffect(() => {
    getMatchingWhoolegoods({
      wholegoods: dmsWholeGoods ?? [],
      parts: dmsParts ?? [],
      dmsSetupId: dmsSetup?.id,
      dmsManufacturers: dmsManufacturers,
    });
  }, []);

  React.useEffect(() => {
    if (
      matchingWhoolegoodsMutationResult.isSuccess &&
      matchingWhoolegoodsMutationResult.data &&
      matchingWhoolegoodsMutationResult.data.entityList
    ) {
      var missMatchedArray: LocationWholegood[] = [];
      var missMatchedPartArray: LocationPart[] = [];
      var matchedArray: MatchedProduct[] = [];
      matchingWhoolegoodsMutationResult.data.entityList.forEach((n) => {
        if (n.catalogProduct) {
          matchedArray.push(n);
        } else if (!isManuallyMatched(n)) {
          if (n.dmsProduct) missMatchedArray.push(n.dmsProduct);
          if (n.dmsPart) missMatchedPartArray.push(n.dmsPart);
        }
      });
      dispatch(
        addMatchedProducts([
          ...matchedProducts.filter((m) => m.isManuallyMatched === true),
          ...matchedArray,
        ])
      );
      dispatch(addMissMatchedProducts(missMatchedArray));
      dispatch(addMissMatchedParts(missMatchedPartArray));
    }
  }, [matchingWhoolegoodsMutationResult]);
  const isManuallyMatched = (product: MatchedProduct) => {
    if (product.dmsProduct) {
      if (
        matchedProducts.some(
          (p) =>
            p.dmsProduct?.model === product.dmsProduct?.model &&
            p.dmsProduct?.mfrCode === product.dmsProduct?.mfrCode
        )
      )
        return true;
      return false;
    } else if (product.dmsPart) {
      if (
        matchedProducts.some(
          (p) => p.dmsPart?.inventoryPartId === product.dmsPart?.inventoryPartId
        )
      )
        return true;
      return false;
    }
  };
  const onDialogClose = () => {
    setConfirmDialog(false);
  };
  React.useEffect(() => {
    if (productByIdMutationResult.isSuccess) {
      setSelectedProduct(productByIdMutationResult.data.entity);
    }
  }, [productByIdMutationResult]);

  const onDialogSuccess = () => {
    dispatch(removeMatchProduct(selectedItem as MatchedProduct));
    setConfirmDialog(false);
  };
  const handleClose = () => {
    setFormOpen(false);
  };

  return (
    <>
      <Box height={620}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
            mt: 2,
            mb: 2,
          }}
        >
          <Button
            size="small"
            variant="outlined"
            onClick={() => {
              handleBack();
            }}
          >
            Back
          </Button>
          <Button
            size="small"
            variant="contained"
            disabled={matchingWhoolegoodsMutationResult.isLoading}
            onClick={handleNext}
          >
            Next
          </Button>
        </Box>
        <MatchingWholegoodsGrid
          data={matchedProducts}
          isLoading={matchingWhoolegoodsMutationResult.isLoading}
          productByIdMutation={productByIdMutation}
          setConfirmDialog={setConfirmDialog}
          setFormOpen={setFormOpen}
          setSelectedItem={setSelectedItem}
          setstock={setstock}
        ></MatchingWholegoodsGrid>
      </Box>
      <AppConfirmDialog
        headerText="Are you sure?"
        bodyText="This product will be removed from Matched Product."
        onFail={onDialogClose}
        onSuccess={onDialogSuccess}
        handleClose={onDialogClose}
        isOpen={confirmDialog}
      />
      <ProductDetail
        isOpen={Formopen}
        handleClose={handleClose}
        productData={selectedProduct}
        Loading={productByIdMutationResult.isLoading}
        locations={locations}
      />
      <AppConfirmDialog
        headerText="Confirm Navigation"
        bodyText="Are you sure you want to go back? You may lose some data."
        onFail={() => {
          setNavigateOpen(false);
        }}
        onSuccess={() => {
          setNavigateOpen(false);
          handleBack();
        }}
        handleClose={() => {
          setNavigateOpen(false);
        }}
        isOpen={navigateOpen}
      />
    </>
  );
};

export default MatchingProducts;
